import { Box, PlatformDialog } from "@platform/style";
import { Grid2 as Grid, Typography } from "@mui/material";
import React from "react";
import { getIdentifier } from "../utils/getIdentifier";

interface CancelWorkItemDialogProps {
  workItemId: string;
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const CancelWorkItemDialog = ({
  workItemId,
  open,
  onClose,
  onSubmit,
}: CancelWorkItemDialogProps) => {
  return (
    <PlatformDialog
      destructive
      open={open}
      onSubmit={onSubmit}
      onClose={onClose}
      submitLabel={"Yes, cancel work item"}
      title={"Cancel work item?"}
    >
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        alignItems="flex-start"
        spacing={2}
        sx={{ mt: "10px" }}
      >
        <Box>
          <Typography variant={"h5"}>
            Are you sure you want to cancel work item #{getIdentifier(workItemId)}?
          </Typography>
        </Box>
        <Box>
          <Typography variant={"body3"}>This action is final and cannot be undone.</Typography>
        </Box>
      </Grid>
    </PlatformDialog>
  );
};
